export interface Author {
    name: string;
    slug: string;
    bio: string;
    avatar?: string;
    role: string;
    social?: {
        twitter?: string;
        linkedin?: string;
        website?: string;
    };
}

// Central author registry.
// Add a new entry here whenever a new author publishes a post.
// The `slug` is derived from the author name used in the DB: nameToSlug(name)
const AUTHORS: Author[] = [
    {
        name: 'VibeVite Team',
        slug: 'vibevite-team',
        role: 'Content Team',
        bio: 'The VibeVite Team is passionate about helping people create unforgettable memories for their special occasions. We write about event planning, video messages, live streaming, and creative ways to bring loved ones together — no matter where they are.',
        avatar: '/images/brand-logo/vibevite-logo-500x200.webp',
        social: {
            twitter: 'https://twitter.com/vibevite',
            website: 'https://vibevite.com',
        },
    },
];

/** Convert an author's display name to a URL slug. */
export function nameToSlug(name: string): string {
    return name
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-');
}

/** Look up an author profile by their display name (case-insensitive). */
export function getAuthorByName(name: string): Author | null {
    const slug = nameToSlug(name);
    return AUTHORS.find((a) => a.slug === slug) ?? null;
}

/** Look up an author profile by slug. */
export function getAuthorBySlug(slug: string): Author | null {
    return AUTHORS.find((a) => a.slug === slug) ?? null;
}

/** Return all registered authors. */
export function getAllAuthors(): Author[] {
    return AUTHORS;
}
